<div *ngIf="isLoading" class="flex items-center justify-center h-screen">
  <p-progressSpinner></p-progressSpinner>
</div>

<div class="container px-4 py-7">
  <div class="w-full form-container">
    <div class="w-full p-6 bg-white rounded-md shadow-lg">
      <h2 class="mb-4 text-2xl font-bold">New Customer</h2>
      <form [formGroup]="customerForm" (ngSubmit)="onSubmit()">
        <div class="mb-4 form-group">
          <label for="first_name" class="block text-sm font-medium text-gray-700"
            >First Name:</label
          >
          <input
            pInputText
            id="first_name"
            formControlName="first_name"
            class="w-full mt-1"
          />
          <small
            *ngIf="
              customerForm.get('first_name')?.invalid &&
              customerForm.get('first_name')?.touched
            "
            class="text-red-500"
          >
            First Name is required
          </small>
        </div>
        <div class="mb-4 form-group">
          <label for="last_name" class="block text-sm font-medium text-gray-700"
            >Last Name:</label
          >
          <input
            pInputText
            id="last_name"
            formControlName="last_name"
            class="w-full mt-1"
          />
          <small
            *ngIf="
              customerForm.get('last_name')?.invalid &&
              customerForm.get('last_name')?.touched
            "
            class="text-red-500"
          >
            Last Name is required
          </small>
        </div>
        <div class="mb-4 form-group">
          <label for="email" class="block text-sm font-medium text-gray-700"
            >Email:</label
          >
          <input
            pInputText
            id="email"
            formControlName="email"
            class="w-full mt-1"
          />
          <small
            *ngIf="
              customerForm.get('email')?.invalid &&
              customerForm.get('email')?.touched
            "
            class="text-red-500"
          >
          Email is required
          </small>
        </div>

        <div class="mb-4 form-group">
          <label for="email" class="block text-sm font-medium text-gray-700"
            >Line 1:</label
          >
          <input
            pInputText
            id="line1"
            formControlName="line1"
            class="w-full mt-1"
          />
          <small
            *ngIf="
              customerForm.get('line1')?.invalid &&
              customerForm.get('line1')?.touched
            "
            class="text-red-500"
          >
          Line 1 is required
          </small>
        </div>

        <div class="flex justify-start py-4">
          <button
            pButton
            type="submit"
            [disabled]="customerForm.invalid"
            class="rounded-md primary-btn"
          >
          Create
        </button>
        </div>
      </form>
    </div>
  </div>
</div>
